import { IconConfig } from "../types";

export const balloon:IconConfig =  {
  type: 'complex' as const,
  viewBox: '0 0 94 94', // Estimé d'après les coordonnées max du SVG
  elements: [
    {
      type: 'symbol',
      id: 'balloon-logo',
      children: [
        {
          type: 'g',
          id: 'Group-1138',
          children: [
            {
              type: 'g',
              id: 'Group-1134',
              children: [
                {
                  type: 'path',
                  id: 'Path-1309',
                  d: 'M53.003 93.961a1.38 1.38 0 0 1-1.35-1.113c-1.927-9.837.243-15.422 2.34-20.823a44 44 0 0 0 2.392-7.473 1.377 1.377 0 0 1 2.7.541 46.7 46.7 0 0 1-2.525 7.928c-2.046 5.268-3.978 10.243-2.2 19.3a1.377 1.377 0 0 1-1.087 1.616 1.4 1.4 0 0 1-.27.024'
                }
              ]
            },
            {
              type: 'g',
              id: 'Group-1135',
              children: [
                {
                  type: 'path',
                  id: 'Path-1310',
                  d: 'M40.999 93.964a1.378 1.378 0 0 1-1.353-1.642c1.774-9.054-.159-14.029-2.2-19.3a46.7 46.7 0 0 1-2.525-7.928 1.377 1.377 0 0 1 2.7-.541 44 44 0 0 0 2.392 7.472c2.1 5.4 4.267 10.987 2.34 20.823a1.38 1.38 0 0 1-1.354 1.116'
                }
              ]
            },
            {
              type: 'g',
              id: 'Group-1136',
              children: [
                {
                  type: 'path',
                  id: 'Path-1311',
                  d: 'M25.651 93.961a1.378 1.378 0 0 1-1.353-1.642 30.5 30.5 0 0 0 .351-10.927 1.377 1.377 0 0 1 2.717-.447 33.2 33.2 0 0 1-.366 11.9 1.38 1.38 0 0 1-1.349 1.116'
                }
              ]
            },
            {
              type: 'g',
              id: 'Group-1137',
              children: [
                {
                  type: 'path',
                  id: 'Path-1312',
                  d: 'M68.352 93.961a1.38 1.38 0 0 1-1.35-1.113 33.2 33.2 0 0 1-.366-11.9 1.377 1.377 0 0 1 2.717.447 30.5 30.5 0 0 0 .351 10.927 1.377 1.377 0 0 1-1.087 1.616 1.4 1.4 0 0 1-.265.023'
                }
              ]
            }
          ]
        },
        {
          type: 'g',
          id: 'Group-1139',
          children: [
            {
              type: 'path',
              id: 'Path-1313',
              d: 'M13.268 36.46C3.583 39.06-2.047 49.451.693 59.679c4.975 18.568 24.323 20.628 24.323 20.628s15.726-11.458 10.751-30.026c-2.741-10.228-12.814-16.416-22.5-13.821Z'
            }
          ]
        },
        {
          type: 'g',
          id: 'Group-1140',
          children: [
            {
              type: 'path',
              id: 'Path-1314',
              d: 'M8.863 57.49c-2.343-8.743 1.431-17.607 8.625-21.618a17.3 17.3 0 0 0-4.221.588C3.583 39.055-2.047 49.451.694 59.674c4.975 18.568 24.323 20.628 24.323 20.628a27.5 27.5 0 0 0 3.51-3.24c-6.052-1.86-16.246-6.826-19.663-19.577Z'
            }
          ]
        },
        {
          type: 'g',
          id: 'Group-1141',
          children: [
            {
              type: 'path',
              id: 'Path-1315',
              d: 'M31.133 81.213 20.172 84.15a2.837 2.837 0 1 1-1.469-5.481l10.962-2.937a2.837 2.837 0 0 1 1.469 5.481Z'
            }
          ]
        },
        {
          type: 'g',
          id: 'Group-1142',
          children: [
            {
              type: 'path',
              id: 'Path-1316',
              d: 'M24.918 79.942a2.837 2.837 0 0 1 2.006-3.475l-8.221 2.2a2.837 2.837 0 1 0 1.469 5.481l8.221-2.2a2.837 2.837 0 0 1-3.475-2.006'
            }
          ]
        },
        {
          type: 'g',
          id: 'Group-1143',
          children: [
            {
              type: 'path',
              id: 'Path-1317',
              d: 'M80.734 36.46c-9.685-2.6-19.759 3.593-22.5 13.821-4.975 18.568 10.751 30.026 10.751 30.026s19.348-2.06 24.323-20.628c2.741-10.228-2.889-20.624-12.574-23.219'
            }
          ]
        },
        {
          type: 'g',
          id: 'Group-1144',
          children: [
            {
              type: 'path',
              id: 'Path-1318',
              d: 'M66.404 52.47c2.343-8.743 10.043-14.532 18.279-14.409a17.3 17.3 0 0 0-3.949-1.6c-9.685-2.6-19.759 3.593-22.5 13.821-4.975 18.568 10.751 30.026 10.751 30.026a27.5 27.5 0 0 0 4.66-1.051c-4.311-4.637-10.657-14.035-7.241-26.786Z'
            }
          ]
        },
        {
          type: 'g',
          id: 'Group-1145',
          children: [
            {
              type: 'path',
              id: 'Path-1319',
              d: 'm73.83 84.15-10.962-2.937a2.837 2.837 0 1 1 1.469-5.481l10.962 2.937a2.837 2.837 0 0 1-1.469 5.481'
            }
          ]
        },
        {
          type: 'g',
          id: 'Group-1146',
          children: [
            {
              type: 'path',
              id: 'Path-1320',
              d: 'M69.083 79.941a2.837 2.837 0 0 1 3.475-2.006l-8.221-2.2a2.837 2.837 0 1 0-1.469 5.481l8.221 2.2a2.837 2.837 0 0 1-2.006-3.475'
            }
          ]
        },
        {
          type: 'g',
          id: 'Group-1147',
          children: [
            {
              type: 'path',
              id: 'Path-1321',
              d: 'M74.956.849c-13.9-3.725-28.364 5.157-32.3 19.84-7.142 26.654 15.432 43.1 15.432 43.1s27.774-2.957 34.916-29.611C96.938 19.496 88.857 4.573 74.953.848Z'
            }
          ]
        },
        {
          type: 'g',
          id: 'Group-1148',
          children: [
            {
              type: 'path',
              id: 'Path-1322',
              d: 'M54.386 23.831C57.749 11.281 68.803 2.97 80.622 3.147a24.8 24.8 0 0 0-5.669-2.3c-13.9-3.725-28.364 5.157-32.3 19.84-7.142 26.654 15.432 43.1 15.432 43.1a39.5 39.5 0 0 0 6.689-1.508c-6.183-6.653-15.293-20.143-10.388-38.448'
            }
          ]
        },
        {
          type: 'g',
          id: 'Group-1149',
          children: [
            {
              type: 'path',
              id: 'Path-1323',
              d: 'm62.935 67.634-10.962-2.937a2.837 2.837 0 0 1 1.469-5.481l10.962 2.937a2.837 2.837 0 1 1-1.469 5.481'
            }
          ]
        },
        {
          type: 'g',
          id: 'Group-1150',
          children: [
            {
              type: 'path',
              id: 'Path-1324',
              d: 'M58.188 63.425a2.837 2.837 0 0 1 3.475-2.006l-8.221-2.2a2.837 2.837 0 1 0-1.469 5.481l8.221 2.2a2.837 2.837 0 0 1-2.006-3.475'
            }
          ]
        },
        {
          type: 'g',
          id: 'Group-1157',
          children: [
            {
              type: 'g',
              id: 'Group-1153',
              children: [
                {
                  type: 'g',
                  id: 'Group-1151',
                  transform: 'translate(45.715 17.444)',
                  children: [
                    {
                      type: 'path',
                      id: 'Ellipse-96',
                      d: 'M4.644 0C7.207 0 9.288 2.611 9.288 5.832S7.207 11.664 4.644 11.664 0 9.053 0 5.832 2.081 0 4.644 0Z',
                      transform: 'rotate(-74.991 5.848 4.487)'
                    }
                  ]
                },
                {
                  type: 'g',
                  id: 'Group-1152',
                  transform: 'translate(76.255 25.625)',
                  children: [
                    {
                      type: 'path',
                      id: 'Ellipse-97',
                      d: 'M4.644 0C7.207 0 9.288 2.611 9.288 5.832S7.207 11.664 4.644 11.664 0 9.053 0 5.832 2.081 0 4.644 0Z',
                      transform: 'rotate(-74.991 5.848 4.487)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'g',
              id: 'Group-1154',
              children: [
                {
                  type: 'path',
                  id: 'Path-1325',
                  d: 'M56.996 21.324a1.378 1.378 0 0 1-1.331-1.734l.588-2.192a1.377 1.377 0 1 1 2.66.713l-.588 2.192a1.38 1.38 0 0 1-1.329 1.021'
                }
              ]
            },
            {
              type: 'g',
              id: 'Group-1155',
              children: [
                {
                  type: 'path',
                  id: 'Path-1326',
                  d: 'M69.717 26.108a5.71 5.71 0 0 1-5.131-3.205 1.377 1.377 0 1 1 2.474-1.21 2.958 2.958 0 0 0 4.313 1.156 1.377 1.377 0 1 1 1.537 2.285 5.7 5.7 0 0 1-3.193.974'
                }
              ]
            },
            {
              type: 'g',
              id: 'Group-1156',
              children: [
                {
                  type: 'path',
                  id: 'Path-1327',
                  d: 'M83.943 28.479a1.378 1.378 0 0 1-1.331-1.734 1.253 1.253 0 0 0-2.421-.648 1.377 1.377 0 1 1-2.66-.713 4.007 4.007 0 1 1 7.741 2.074 1.38 1.38 0 0 1-1.329 1.021'
                }
              ]
            }
          ]
        },
        {
          type: 'g',
          id: 'Group-1158',
          children: [
            {
              type: 'path',
              id: 'Path-1328',
              d: 'M19.046.849C5.142 4.574-2.939 19.497.995 34.179c7.142 26.655 34.916 29.608 34.916 29.608s22.574-16.444 15.432-43.1C47.409 6.006 32.949-2.876 19.046.849'
            }
          ]
        },
        {
          type: 'g',
          id: 'Group-1159',
          children: [
            {
              type: 'path',
              id: 'Path-1329',
              d: 'M12.723 31.037C9.36 18.486 14.777 5.767 25.1.004a24.8 24.8 0 0 0-6.059.845C5.142 4.574-2.939 19.496.995 34.179 8.137 60.834 35.911 63.79 35.911 63.79a39.5 39.5 0 0 0 5.039-4.651c-8.688-2.67-23.322-9.8-28.227-28.1Z'
            }
          ]
        },
        {
          type: 'g',
          id: 'Group-1160',
          children: [
            {
              type: 'path',
              id: 'Path-1330',
              d: 'm42.028 64.697-10.962 2.937a2.837 2.837 0 1 1-1.469-5.481l10.962-2.937a2.837 2.837 0 1 1 1.469 5.481'
            }
          ]
        },
        {
          type: 'g',
          id: 'Group-1161',
          children: [
            {
              type: 'path',
              id: 'Path-1331',
              d: 'M35.813 63.425a2.837 2.837 0 0 1 2.006-3.475l-8.221 2.2a2.837 2.837 0 0 0 1.469 5.481l8.221-2.2a2.837 2.837 0 0 1-3.475-2.006'
            }
          ]
        },
        {
          type: 'g',
          id: 'Group-1168',
          children: [
            {
              type: 'g',
              id: 'Group-1165',
              children: [
                {
                  type: 'g',
                  id: 'Group-1162',
                  transform: 'translate(5.208 25.981)',
                  children: [
                    {
                      type: 'path',
                      id: 'Ellipse-98',
                      d: 'M5.558 0C8.627 0 11.116 1.981 11.116 4.426S8.627 8.852 5.558 8.852 0 6.871 0 4.426 2.489 0 5.558 0Z',
                      transform: 'rotate(-15.009 10.927 1.44)'
                    }
                  ]
                },
                {
                  type: 'g',
                  id: 'Group-1163',
                  transform: 'translate(34.31 18.178)',
                  children: [
                    {
                      type: 'path',
                      id: 'Ellipse-99',
                      d: 'M5.558 0C8.627 0 11.116 1.981 11.116 4.426S8.627 8.852 5.558 8.852 0 6.871 0 4.426 2.489 0 5.558 0Z',
                      transform: 'rotate(-15.009 10.927 1.44)'
                    }
                  ]
                },
                {
                  type: 'g',
                  id: 'Group-1164',
                  children: [
                    {
                      type: 'path',
                      id: 'Path-1332',
                      d: 'M29.716 23.353c-.717-2.675-2.722-2.407-5.113-1.767s-4.261 1.411-3.545 4.086a4.51 4.51 0 1 0 8.657-2.32Z'
                    }
                  ]
                }
              ]
            },
            {
              type: 'g',
              id: 'Group-1166',
              children: [
                {
                  type: 'path',
                  id: 'Path-1333',
                  d: 'M11.245 27.728a1.38 1.38 0 0 1-1.329-1.021l-.588-2.192a1.377 1.377 0 0 1 2.66-.713l.588 2.192a1.378 1.378 0 0 1-1.331 1.734'
                }
              ]
            },
            {
              type: 'g',
              id: 'Group-1167',
              children: [
                {
                  type: 'path',
                  id: 'Path-1334',
                  d: 'M38.551 20.412a1.38 1.38 0 0 1-1.329-1.021l-.587-2.192a1.377 1.377 0 1 1 2.66-.713l.587 2.192a1.378 1.378 0 0 1-1.331 1.734'
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}
